
import { deliveryQuery } from '@/apis/dispatcher'
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import formatTime from "../../utils/format"
import paging from '@/components/paging/paging.vue'

export default defineComponent({
    components:{
        paging
    },
    setup() {
        const state = reactive({
            searchValue: '',
            imageUrl: '',
            total: 0,
            dispatcherList: [

            ] as any,
            params: {
                    pageSize: 12,
                    page: 1,
                    limit: true
                } as any,
            dispatcherQuery() {
                // console.log(state.searchValue)
                    state.params.search = state.searchValue
                deliveryQuery(state.params).then((res: any) => {
                    console.log('配送员查询', res)
                    state.total = res.data.total
                    if (res.data.list != null) {
                        res.data.list.forEach((item: any) => {
                            item.face_img = `data:image/jpg;base64,${item.face_img}`
                            // item.face_img = str.replace(/[\r\n]/g, '')
                            // item.face_img = require(`${item.face_img}`)
                            item.create_time = formatTime("YYYY-mm-dd", item.create_time)
                        })
                    }
                    state.dispatcherList = res.data.list?res.data.list:[]
                })
            },
            sizechangePage(val:number) {
                state.params.page = 1
                state.params.pageSize = val
                state.dispatcherQuery()
            },
            // 页码切换
            changePage(val:number){
                state.params.page = val
                state.dispatcherQuery()
            },
            init() {
                state.dispatcherQuery()
            }
        })

        onMounted(() => {
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
